// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .max-600 .modal-lg {
  max-width: 600px !important;
}

.approval-popup-modal h3 {
  color: rgb(48, 62, 78);
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 8px;
}

.approval-popup-modal p {
  line-height: 22px;
}

.approval-popup-modal .card {
  border: none;
}

.approval-popup-modal .card-body {
  padding: 25px;
}

.approval-popup-modal .card-footer {
  background: rgb(248, 248, 248);
  border-top: rgb(209, 211, 219) solid 1px;
  padding: 15px 25px;
}

.approval-popup-modal .card-header {
  background: rgb(48, 62, 78);
  border: none;
  border-radius: 0;
  color: rgb(255, 255, 255);
  font-size: 24px;
  font-weight: 700;
  height: 62px;
  line-height: 60px;
  padding: 0 25px;
}

.approval-popup-modal .card-header .close:focus {
  box-shadow: none;
  outline: none;
}

.approval-popup-modal .card-header .close, .approval-popup-modal .card-header .close:hover {
  color: rgb(255, 255, 255);
  font-size: 37px;
  margin: 9px -7px 0 0;
  opacity: 1;
}

.approval-popup-modal .label-name {
  color: rgb(48, 62, 78);
  font-size: 16px;
  font-weight: 600;
}

.btn.aud-btn {
  color: rgb(255, 255, 255);
  font-size: 15px;
}

.font-16 {
  font-size: 16px;
}

.font-18 {
  font-size: 18px !important;
}

.p-23 {
  padding: 23px !important;
}

.set-space {
  padding: 7px 36px 0 !important;
}

.theme-bg {
  background: rgb(48, 62, 78);
}

.yes-bg {
  background: rgb(245, 246, 250);
}
`, "",{"version":3,"sources":["webpack://./src/app/modules/intakes/approval-popup/approval-popup.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["::ng-deep .max-600 .modal-lg {\n  max-width: 600px !important;\n}\n\n.approval-popup-modal h3 {\n  color: rgb(48, 62, 78);\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.approval-popup-modal p {\n  line-height: 22px;\n}\n\n.approval-popup-modal .card {\n  border: none;\n}\n\n.approval-popup-modal .card-body {\n  padding: 25px;\n}\n\n.approval-popup-modal .card-footer {\n  background: rgb(248, 248, 248);\n  border-top: rgb(209, 211, 219) solid 1px;\n  padding: 15px 25px;\n}\n\n.approval-popup-modal .card-header {\n  background: rgb(48, 62, 78);\n  border: none;\n  border-radius: 0;\n  color: rgb(255, 255, 255);\n  font-size: 24px;\n  font-weight: 700;\n  height: 62px;\n  line-height: 60px;\n  padding: 0 25px;\n}\n\n.approval-popup-modal .card-header .close:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n.approval-popup-modal .card-header .close, .approval-popup-modal .card-header .close:hover {\n  color: rgb(255, 255, 255);\n  font-size: 37px;\n  margin: 9px -7px 0 0;\n  opacity: 1;\n}\n\n.approval-popup-modal .label-name {\n  color: rgb(48, 62, 78);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.btn.aud-btn {\n  color: rgb(255, 255, 255);\n  font-size: 15px;\n}\n\n.font-16 {\n  font-size: 16px;\n}\n\n.font-18 {\n  font-size: 18px !important;\n}\n\n.p-23 {\n  padding: 23px !important;\n}\n\n.set-space {\n  padding: 7px 36px 0 !important;\n}\n\n.theme-bg {\n  background: rgb(48, 62, 78);\n}\n\n.yes-bg {\n  background: rgb(245, 246, 250);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
